export default {
  name: 'productSearch',
  list: 'list',
  meta: 'meta',
  query: 'query',
  fetchId: 'fetchId',
  selected: 'selected',
  listId: 'listId'
};
